import { useRoutes } from "react-router-dom";
import Landing from './pages/Landing';
import NotFound from './pages/NotFound';
import AlannahJoke from './pages/AlannahJoke';
import About from './pages/About';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import Ventures from './pages/Ventures';

// ----------------------------------------------------------------------
export default function Router() {
    return useRoutes([
        {
            path: '/', element: (
                <Landing />
            )
        },
        {
            path: '/alannah-joke', element: (
                <AlannahJoke />
            )
        },
        {
            path: '/about', element: (
                <About />
            )
        },
        {
            path: '/ventures', element: (
                <Ventures />
            )
        },
        {
            path: '/privacy-policy', element: (
                <PrivacyPolicy />
            )
        },
        {
            path: '/terms-of-use', element: (
                <TermsOfUse />
            )
        },
        { path: '*', element: <NotFound /> },
    ]);
}